import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createLogsAction = createActionCreator(constant.logs, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);

let operatingLogs = Urls.MonitorUrl.phoneDetailData;

//获取操作日志
export const getLogs = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().operaMonitor.search;
            let response = await request(operatingLogs, 'post', search);
            console.log(response)
            dispatch(createSearchAction({ total: response.total }));
            dispatch(createLogsAction(response.list));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/phoneDetail/action.js